import type { ISummary } from "app/store/models/summary";
import type { AxiosResponse } from "axios";
import instance from "data/axios-setup";

class SummaryService {
  async getSummary(): Promise<
    AxiosResponse<{ data: ISummary; message: string }>
  > {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await instance.get("admin/summary");
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  }
}

export default new SummaryService();
